import Media from './Media'
import EventEmitter from 'src/helpers/EventEmitter'

const Events = {
  PROGRESS: 'progress',
  COMPLETED: 'completed'
}

class MediaService {
  constructor() {
    Object.assign(this, EventEmitter)
    this.media = []
    this._progress = 0
  }

  _updateProgress = () => {
    let progress = 0
    for (const media of this.media) {
      let mediaProgress = 0
      for (const track of media.tracks) {
        mediaProgress += track.loading.progress // * (1 / media.tracks.length)
      }
      mediaProgress *= 1 / this.media.length
      progress += mediaProgress
    }
    if (this._progress !== progress) {
      this.emit(Events.PROGRESS, progress)
    }
    this._progress = progress
    this.rafId = window.requestAnimationFrame(this._updateProgress)
  }

  load = manifest => {
    this.media = []
    this._progress = 0

    // CREATE ELEMENTS
    for (const config of manifest) {
      let media = new Media(config)
      this.media.push(media)
    }

    // UPDATE
    this.rafId = window.requestAnimationFrame(this._updateProgress)

    // LOAD
    return new Promise(resolve => {
      ;(async () => {
        for (let media of this.media) {
          await media.load()
        }
        window.cancelAnimationFrame(this.rafId)
        this._progress = 1
        this.emit(Events.PROGRESS, this._progress)
        this.emit(Events.COMPLETED)
        console.log(`MediaService loaded`)
        resolve()
      })()
    })
  }

  get = id => {
    return this.media.filter(media => {
      return media.id === id
    })[0]
  };

  stopAll = () => {
    for (let media of this.media) {
      media.pause()
      media.currentTime = 0
    }
  }

  get progress() {
    return this._progress
  }
}

let service = new MediaService()
service.Events = Events
window.MediaService = service
export default service
